// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MachineForm.module.css */
.CreateMachineForm_container__QmSrW {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 300px;
  padding: 16px;
  color: black;
  /* border-radius: 4px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12); */
}

.CreateMachineForm_form__WfK5Z {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}

.CreateMachineForm_label__p0bQa {
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 16px;
}

.CreateMachineForm_input__zH6fu {
  width: 100%;
  padding: 8px;
  margin-bottom: 16px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  box-sizing: border-box; /* Add this property */
}

.CreateMachineForm_input__zH6fu:focus {
  border-color: #3f51b5;
  box-shadow: 0 0 0 1px #3f51b5;
}

.CreateMachineForm_button__2MbSd {
  width: 100%;
  padding: 8px;
  background-color: #3f51b5;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.CreateMachineForm_button__2MbSd:hover {
  background-color: #283593;
}

.CreateMachineForm_button__2MbSd:disabled {
  background-color: rgba(0, 0, 0, 0.12);
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/MachineModal/CreateMachineForm.module.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ;;yEAEuE;AACzE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB,EAAE,sBAAsB;AAChD;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB","sourcesContent":["/* MachineForm.module.css */\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 300px;\n  padding: 16px;\n  color: black;\n  /* border-radius: 4px;\n  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12); */\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n}\n\n.label {\n  margin-bottom: 8px;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.input {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 16px;\n  border: 1px solid rgba(0, 0, 0, 0.23);\n  border-radius: 4px;\n  font-size: 16px;\n  outline: none;\n  box-sizing: border-box; /* Add this property */\n}\n\n.input:focus {\n  border-color: #3f51b5;\n  box-shadow: 0 0 0 1px #3f51b5;\n}\n\n.button {\n  width: 100%;\n  padding: 8px;\n  background-color: #3f51b5;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.button:hover {\n  background-color: #283593;\n}\n\n.button:disabled {\n  background-color: rgba(0, 0, 0, 0.12);\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CreateMachineForm_container__QmSrW`,
	"form": `CreateMachineForm_form__WfK5Z`,
	"label": `CreateMachineForm_label__p0bQa`,
	"input": `CreateMachineForm_input__zH6fu`,
	"button": `CreateMachineForm_button__2MbSd`
};
export default ___CSS_LOADER_EXPORT___;
